<button
  type="button"
  pButton
  [severity]="config().severity"
  [outlined]="config().outlined || false"
  [text]="config().text"
  [size]="primeNgSize()!"
  [fluid]="config().fluid"
  [raised]="config().raised"
  [rounded]="config().rounded"
  [loading]="isLoading()"
  [disabled]="disabled() || config().loading"
  [attr.aria-label]="config().ariaLabel"
  [ngClass]="{
    'icon-only-large': config().iconOnly && config().size === 'large',
    'icon-only-small': config().iconOnly && config().size === 'small',
    'icon-only-medium': config().iconOnly && (!config().size || config().size === 'medium'),
    'p-button-outlined': config().outlined,
  }"
  class="flex items-center justify-center gap-2 font-(family-name:--button-font-family) font-(--button-font-weight)"
  (click)="onClick()"
>
  @if (config().leftIcon) {
    <app-icon
      [name]="config().leftIcon!"
      [size]="iconSize()"
      [color]="iconColor()"
      [ngClass]="{ invisible: config().loading }"
      class="icon"
    ></app-icon>
  }

  <div
    [hidden]="config().iconOnly"
    [ngClass]="{ invisible: config().loading }"
  >
    {{ config().label | translate }}
  </div>

  @if (config().rightIcon) {
    <app-icon
      [name]="config().rightIcon!"
      [size]="iconSize()"
      [color]="iconColor()"
      [ngClass]="{ invisible: config().loading }"
      class="icon"
    ></app-icon>
  }
</button>
